/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  getU16Decoder,
  getU16Encoder,
  getU32Decoder,
  getU32Encoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";
import {
  getAccessTierDecoder,
  getAccessTierEncoder,
  type AccessTier,
  type AccessTierArgs,
} from ".";

export type GhostStakedEvent = {
  agent: Address;
  amount: bigint;
  unlockAt: bigint;
  reputationBoostBps: number;
  tier: AccessTier;
  dailyApiCalls: number;
  votingPower: bigint;
};

export type GhostStakedEventArgs = {
  agent: Address;
  amount: number | bigint;
  unlockAt: number | bigint;
  reputationBoostBps: number;
  tier: AccessTierArgs;
  dailyApiCalls: number;
  votingPower: number | bigint;
};

export function getGhostStakedEventEncoder(): FixedSizeEncoder<GhostStakedEventArgs> {
  return getStructEncoder([
    ["agent", getAddressEncoder()],
    ["amount", getU64Encoder()],
    ["unlockAt", getI64Encoder()],
    ["reputationBoostBps", getU16Encoder()],
    ["tier", getAccessTierEncoder()],
    ["dailyApiCalls", getU32Encoder()],
    ["votingPower", getU64Encoder()],
  ]);
}

export function getGhostStakedEventDecoder(): FixedSizeDecoder<GhostStakedEvent> {
  return getStructDecoder([
    ["agent", getAddressDecoder()],
    ["amount", getU64Decoder()],
    ["unlockAt", getI64Decoder()],
    ["reputationBoostBps", getU16Decoder()],
    ["tier", getAccessTierDecoder()],
    ["dailyApiCalls", getU32Decoder()],
    ["votingPower", getU64Decoder()],
  ]);
}

export function getGhostStakedEventCodec(): FixedSizeCodec<
  GhostStakedEventArgs,
  GhostStakedEvent
> {
  return combineCodec(
    getGhostStakedEventEncoder(),
    getGhostStakedEventDecoder(),
  );
}
